<template>
    <div class="container">
        <div class="content">
            <div class="conList_title">
                <div class="item_title">标题</div>
                <div class="item_time">更新日期</div>
                <div class="operation"></div>
            </div>
            <div class="conList_items">
                <div class="item_title">
                    <div>搜索不到设备</div>
                </div>
                <div class="item_time">{{ formatDate(allDoc.resTip.createdAt, "y/M/d h:m") }}</div>
                <div class="operation">
                    <a @click="edit('搜索不到设备', allDoc.resTip)">编辑</a>
                </div>
            </div>
            <div class="conList_items">
                <div class="item_title">
                    <div>用户协议</div>
                </div>
                <div class="item_time">{{ formatDate(allDoc.resUserAgreement.createdAt, "y/M/d h:m") }}</div>
                <div class="operation">
                    <a @click="edit('用户协议', allDoc.resUserAgreement)">编辑</a>
                </div>
            </div>
            <div class="conList_items">
                <div class="item_title">
                    <div>隐私协议</div>
                </div>
                <div class="item_time">{{ formatDate(allDoc.resPrivacyPolicy.createdAt, "y/M/d h:m") }}</div>
                <div class="operation">
                    <a @click="edit('隐私协议', allDoc.resPrivacyPolicy)">编辑</a>
                </div>
            </div>
            <div class="conList_items">
                <div class="item_title">
                    <div>使用帮助</div>
                </div>
                <div class="item_time">{{ formatDate(allDoc.resHelp.createdAt, "y/M/d h:m") }}</div>
                <div class="operation">
                    <a @click="edit('使用帮助', allDoc.resHelp)">编辑</a>
                </div>
            </div>
            <!--      <div class="conList_items">-->
            <!--        <div class="item_title">-->
            <!--          <div>售后电话</div>-->
            <!--        </div>-->
            <!--        <div class="item_time">{{ formatDate(allDoc.resCompanyInfo.createdAt, "y/M/d h:m") }}</div>-->
            <!--        <div class="operation">-->
            <!--          <a @click="edit(allDoc.resCompanyInfo)">编辑</a>-->
            <!--        </div>-->
            <!--      </div>-->
            <div class="conList_items">
                <div class="item_title">
                    <div>公司地址及电话</div>
                </div>
                <div class="item_time">{{ formatDate(allDoc.resCompanyInfo.createdAt, "y/M/d h:m") }}</div>
                <div class="operation">
                    <a @click="edit('公司地址及电话', allDoc.resCompanyInfo)">编辑</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getAllDoc, updateUserAgreement, updatePrivacyPolicy, updateHelp, updateCompanyInfo, updateTip } from "@/http/management";
export default {
    name: "management",
    components: {},
    data() {
        return {
            allDoc: {
                resCompanyInfo: {
                    address: "",
                    createdAt: 1577808001000,
                    latitude: 0,
                    longitude: 0,
                    name: "",
                    telephone: "",
                },
                resHelp: {
                    createdAt: 1577808001000,
                },
                resPrivacyPolicy: {
                    createdAt: 1577808001000,
                },
                resTip: {
                    createdAt: 1577808001000,
                },
                resUserAgreement: {
                    createdAt: 1577808001000,
                },
            },
        };
    },
    methods: {
        edit(title, item) {
            // console.log(item)
            this.$router.push({ name: "editor", query: { title: title, item: item } });
        },
        getAllDocHttp() {
            getAllDoc()
                .then((res) => {
                    console.log(res.data.result);
                    if (res.data.errCode === 0) {
                        this.allDoc = res.data.result;
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    },
    watch: {},
    created() {
        this.getAllDocHttp();
    },
};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    min-height: 626px;
    padding-bottom: 76px;
    position: relative;
    .comPage {
        position: absolute;
        left: 0;
        bottom: 0;
    }
}
.comSelect {
    height: 36px;
    margin-right: 30px;
}
.conList_items {
    justify-content: space-between;
    height: 60px;
}
.item_no {
    flex: 0 0 100px;
}
.item_title {
    flex: 0 0 300px;
    max-width: 300px;
    div {
        display: block;
        width: 100%;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.item_image {
    flex: 0 0 200px;
    img {
        height: 80px;
    }
}
.item_time {
    flex: 0 0 130px;
    max-width: 130px;
}
.item_type {
    flex: 0 0 100px;
}
.item_count {
    flex: 0 0 100px;
}

@media only screen and (max-width: 1500px) {
    .item_no {
        flex: 0 0 80px;
    }
}
@media only screen and (max-width: 1400px) {
    .item_no {
        flex: 0 0 70px;
    }
    .item_title {
        flex: 0 0 200px;
        max-width: 200px;
    }
}
</style>
